<template>
  <ol class="questions">
    <li>
      <fieldset>
        <legend>
<!--          <span class="label">I lost my certificate(s) during the</span>-->
<!--          <abbr class="required" name="label-declared-area" title="(required)"-->
<!--            >*</abbr-->
<!--          >-->
        </legend>
        <ul class="choices" id="disasterAreas">
          <li v-for="area in areas" :key="area.id">
            <ValidationProvider rules="required:#label-declared-area">
              <input
                :id="area.id"
                v-model="disasterArea"
                :value="area.name"
                name="Select disaster area"
                type="radio"
                @click="selectArea(area)"
              />
            </ValidationProvider>
            <label :for="area.id">{{ area.name }}</label>
          </li>
          <li></li>
        </ul>
      </fieldset>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    areas: Array,
    value: String,
  },
  computed: {
    disasterArea: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    selectArea(selectedArea) {
      this.areas.forEach((area) => (area.selected = false));
      let area = this.areas.find((area) => area.name === selectedArea.name);
      area.selected = true;
      console.log(this.areas);
    },
  },
};
</script>
